import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getProveedores,
  updateProveedor,
  insertProveedor,
  deleteProveedor,
  getProveedorById,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PROVEEDORES() {
  try {
    const proveedoresData = yield call(getProveedores)
    if (proveedoresData.ok) {
      yield put({
        type: actions.PROVEEDORES_LOAD_SUCCEEDED,
        payload: proveedoresData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Proveedores')
      put({
        type: actions.PROVEEDORES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PROVEEDORES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_PROVEEDOR(action) {
  try {
    const proveedorObj = yield call(insertProveedor, action.payload)
    if (proveedorObj.ok) {
      putMessage(messageType.SUCCESS, 'Proveedor creado correctamente')
      yield put({
        type: actions.PROVEEDOR_INSERT_SUCCEEDED,
        payload: proveedorObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Proveedor')
      yield put({
        type: actions.PROVEEDOR_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Proveedor')
    yield all([
      put({
        type: actions.PROVEEDOR_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PROVEEDOR(action) {
  try {
    const proveedorObj = yield call(updateProveedor, action.payload)
    if (proveedorObj.ok) {
      putMessage(messageType.SUCCESS, 'Proveedor modificado correctamente')
      yield put({
        type: actions.PROVEEDOR_UPDATE_SUCCEEDED,
        payload: proveedorObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Proveedor')
      yield put({
        type: actions.PROVEEDOR_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Proveedor')
    yield all([
      put({
        type: actions.PROVEEDOR_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_PROVEEDOR(action) {
  try {
    const proveedorResult = yield call(deleteProveedor, action.payload)
    if (proveedorResult.ok) {
      putMessage(messageType.SUCCESS, 'Proveedor eliminado correctamente')
      yield put({
        type: actions.PROVEEDOR_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Proveedor')
      yield put({
        type: actions.PROVEEDOR_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Proveedor')
    yield all([
      put({
        type: actions.PROVEEDOR_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PROVEEDOR_BY_ID(action) {
  try {
    const proveedorData = yield call(getProveedorById, action.payload)
    if (proveedorData.ok) {
      yield put({
        type: actions.PROVEEDOR_BYID_LOAD_SUCCEEDED,
        payload: proveedorData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Proveedor')
      put({
        type: actions.PROVEEDOR_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PROVEEDOR_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PROVEEDORES_LOAD_REQUESTED, GET_PROVEEDORES),
    takeEvery(actions.PROVEEDOR_INSERT_REQUESTED, INSERT_PROVEEDOR),
    takeEvery(actions.PROVEEDOR_UPDATE_REQUESTED, UPDATE_PROVEEDOR),
    takeEvery(actions.PROVEEDOR_DELETE_REQUESTED, DELETE_PROVEEDOR),
    takeEvery(actions.PROVEEDOR_BYID_LOAD_REQUESTED, GET_PROVEEDOR_BY_ID),
  ])
}
